/**
 * Checks if a number is odd.
 * @param num - The number to check
 */
export function isOdd(num: number): boolean {
  return num % 2 !== 0;
}
